/*global swal */

import './style.less';

export default function($scope, $state, $stateParams, EventClass) {
  'ngInject';
  const vm = this;
  vm.$onInit = activate;
  vm.$onChanges = update;

  $scope.linksActive = true;
  $scope.pastEvent = true;
  $scope.resultsQueried = false;

  const tempParams = { ...$stateParams };
  delete tempParams.location;

  let routeParams = JSON.stringify(tempParams);

  function activate() {
    $scope.current = $state.current.name;
    $scope.$stateParams = $stateParams;

    _setEventName(vm.event);
    update();

    $scope.resultsQueried = true;
  }

  function update() {
    if (!vm.event) return;
    const externalHasError = vm.event.externals ? vm.event.externals.some(external => !!external.error) : false;
    const navigationEvent = [
      {
        icon: 'fa-info',
        route: `app.eventManager.course.event.event-info(${routeParams})`,
        name: 'Overview',
        current: 'app.eventManager.course.event.event-info',
        active: true
      },
      {
        icon: 'fa-puzzle-piece',
        route: `app.eventManager.course.event.event-addons(${routeParams})`,
        name: 'Integrations',
        current: 'app.eventManager.course.event.event-addons',
        active: true,
        showBadge: externalHasError,
        showError: externalHasError,
        badgeValue: '!',
        badgeClass: 'badge-red'
      },
      {
        icon: 'fa-file-text-o',
        route: `app.eventManager.course.event.materials(${routeParams})`,
        name: 'Materials',
        current: 'app.eventManager.course.event.materials',
        active: true
      },
      {
        icon: 'fa-envelope-o',
        route: `app.eventManager.course.event.invitations(${routeParams})`,
        name: 'Invitations',
        current: 'app.eventManager.course.event.invitations',
        active: true
      },
      {
        icon: 'fa-paper-plane-o',
        route: `app.eventManager.course.event.registrations(${routeParams})`,
        name: 'Registrations',
        opts: { reload: true },
        current: 'app.eventManager.course.event.registrations',
        active: true,
        showBadge: !!vm.event.externalRegistrations && vm.event.externalRegistrations.length,
        badgeValue: vm.event.externalRegistrations ? vm.event.externalRegistrations.length : 0
      },
      {
        icon: 'fa-certificate',
        route: `app.eventManager.course.event.certificates(${routeParams})`,
        name: 'Certificates',
        opts: { reload: true },
        current: 'app.eventManager.course.event.certificates',
        active: true
      },
      {
        icon: 'fa-bar-chart-o',
        route: `app.eventManager.course.event.evaluations(${routeParams})`,
        name: 'Evaluations',
        current: 'app.eventManager.course.event.evaluations',
        active: true
      },
      {
        icon: 'fa-reply',
        route: `app.eventManager.course.event.emails(${routeParams})`,
        name: 'Email Templates',
        current: 'app.eventManager.course.event.emails',
        active: true
      },
      {
        icon: 'fa-download',
        route: `app.eventManager.course.event.reports(${routeParams})`,
        name: 'Reports',
        opts: { reload: true },
        current: 'app.eventManager.course.event.reports',
        active: true
      }
    ];

    const isCourseEventMatch = vm.course && vm.event.course_id === vm.course.course_id;
    const isPastEvent = new Date(vm.event.delivery_date) < new Date();
    const isWebinar = vm.event.delivery_method === 2 || vm.event.delivery_method === 11;

    const externalWebinars = EventClass.externalWebinars(vm.event);

    const hasWebinarAttached =
      isWebinar &&
      (externalWebinars.length ||
        vm.event.webinarKey ||
        vm.event.webinarSessionKey ||
        vm.event.zoomMeetingId ||
        vm.event.zoomWebinarId ||
        vm.event.webexSessionKey ||
        (vm.event.url && vm.event.url.length));

    const isScormEvent = !!vm.event.scorm_id;

    $scope.navigation = navigationEvent;
    $scope.linksActive = isCourseEventMatch;
    $scope.pastEvent = isPastEvent;

    if (isWebinar && !hasWebinarAttached && !isScormEvent) {
      $scope.linksActive = false;
      $state.go('app.eventManager.course.event.event-addons', $stateParams);
    }
  }

  function _setEventName(event) {
    if (event && event.course_name) {
      if ($scope.$parent) $scope.$parent.eventName = event.course_name;
      if ($scope.$parent && $scope.$parent.$parent) $scope.$parent.$parent.eventName = event.course_name;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/navigation/controller.js